export enum RcsAgentRegistrationStatus {
  Created = "CREATED",
  Submitted = "SUBMITTED",
  Verifying = "VERIFYING",
  Verified = "VERIFIED",
  Launching = "LAUNCHING",
  Launched = "LAUNCHED",
  Live = "LIVE",
  Rejected = "REJECTED",
  Failed = "FAILED",
}
